var HebcaMiddleware = HebcaMiddleware || {};
(function ($m) {
    function MiddlewareUiBootstrap() {
    }


    /**
     * 选择证书，如果证书列表为空，则报错，如果证书列表个数1个，则直接返回，否则弹出选择界面
     * @param param
     * {
     *     certs：证书列表对象
     *     success：function(cert){}
     *     fail：function(e){}
     * }
     */
    MiddlewareUiBootstrap.prototype.selectCert = function (param) {
        var selectControl = '<select class="form-control" name="certChooseSelect">';
        for (var i = 0; i < param.certs.length; i++) {
            selectControl += '<option value="' + i + '" >' + param.certs[i].subject.cn + '</option>';
        }
        selectControl += '</select>';

        var content = '<form class="form-horizontal" role="form" >' +
            '<div class="form-group">' +
            '<label for="itemName" class="col-sm-2 control-label">证书:</label>' +
            '<div class="col-sm-8" >' +
            selectControl +
            '</div>' +
            '</div>' +
            '</form>';

        var m = '<div class="modal fade" id="certChooseDialog" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true" style="z-index: 9999; ">' +
            '<div class="modal-dialog">' +
            '<div class="modal-content">' +
            '<div class="modal-header">' +
            '<button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>' +
            '<h4 class="modal-title" id="myModalLabel">选择证书</h4>' +
            '</div>' +
            '<div class="modal-body">' + content + '</div>' +
            '<div class="modal-footer">' +
            '<button type="button" class="btn btn-primary" id="certChooseDialogOk">确 定</button>' +
            '<button type="button" class="btn btn-default" data-dismiss="modal">取 消</button>' +
            '</div>' +
            '</div>' +
            '</div>' +
            '</div>';

        $("body").append(m);
        var clickOk = false;
        $('#certChooseDialog').on('hide.bs.modal',
            function () {
                $("#certChooseDialog").remove();
                if (clickOk == false) {
                    if (param.fail)
                        param.fail(new Error("用户取消操作"));
                }
            });
        $("#certChooseDialogOk").click(function () {
            var selectIndex = $("#certChooseDialog [name=certChooseSelect]").val();
            clickOk = true;
            $("#certChooseDialog").modal('hide');
            param.success(param.certs[selectIndex]);
        });
        $("#certChooseDialog").modal('show');
    };

    /**
     * 选择设备，如果设备列表为空，则报错，如果设备列表个数1个，则直接返回，否则弹出选择界面
     * @param param
     * {
     *     devices：设备列表对象
     *     success：function(device){}
     *     fail：function(e){}
     * }
     */
    MiddlewareUiBootstrap.prototype.selectDevice = function (param) {
        var selectControl = '<select class="form-control" name="deviceChooseSelect">';
        for (var i = 0; i < param.devices.length; i++) {
            selectControl += '<option value="' + i + '" >' + param.devices[i].deviceName + '</option>';
        }
        selectControl += '</select>';

        var content = '<form class="form-horizontal" role="form" >' +
            '<div class="form-group">' +
            '<label for="itemName" class="col-sm-2 control-label">证书设备:</label>' +
            '<div class="col-sm-8" >' +
            selectControl +
            '</div>' +
            '</div>' +
            '</form>';

        var m = '<div class="modal fade" id="deviceChooseDialog" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true" style="z-index: 9999; ">' +
            '<div class="modal-dialog">' +
            '<div class="modal-content">' +
            '<div class="modal-header">' +
            '<button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>' +
            '<h4 class="modal-title" id="myModalLabel">选择设备</h4>' +
            '</div>' +
            '<div class="modal-body">' + content + '</div>' +
            '<div class="modal-footer">' +
            '<button type="button" class="btn btn-primary" id="deviceChooseDialogOk">确 定</button>' +
            '<button type="button" class="btn btn-default" data-dismiss="modal">取 消</button>' +
            '</div>' +
            '</div>' +
            '</div>' +
            '</div>';

        $("body").append(m);
        var clickOk = false;
        $('#deviceChooseDialog').on('hide.bs.modal',
            function () {
                $("#deviceChooseDialog").remove();
                if (clickOk == false) {
                    if (param.fail)
                        param.fail(new Error("用户取消操作"));
                }
            });
        $("#deviceChooseDialogOk").click(function () {
            var selectIndex = $("#deviceChooseDialog [name=deviceChooseSelect]").val();
            clickOk = true;
            $("#deviceChooseDialog").modal('hide');
            param.success(param.devices[selectIndex]);
        });
        $("#deviceChooseDialog").modal('show');
    };

    /**
     * 登录证书
     * @param param
     * {
     *     cert：证书对象
     *     checkPassword：function(password){}  检测密码
     *     success：function(password){}
     *     fail：function(e){}
     * }
     */
    MiddlewareUiBootstrap.prototype.loginCert = function (param) {
        var content = '<form class="form-horizontal" role="form" >' +
            '<div class="form-group">' +
            '<label for="itemName" class="col-sm-2 control-label">证书:</label>' +
            '<div class="col-sm-8" >' +
            '<input type="text" name="itemName" class="form-control" disabled="disabled" value="' + param.cert.subject.cn + '"/>' +
            '</div>' +
            '</div>' +
            '<div class="form-group" id="password-group">' +
            '<label for="loginPassword" class="col-sm-2 control-label">密码:</label>' +
            '<div class="col-sm-8" >' +
            '<input type="password" id="loginPassword" name="loginPassword" class="form-control" placeholder="输入您的证书密码"/>' +
            '</div>' +
            '</div>' +
            '</form>';

        var m = '<div class="modal fade" id="certLoginDialog" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true" style="z-index: 9999; ">' +
            '<div class="modal-dialog">' +
            '<div class="modal-content">' +
            '<div class="modal-header">' +
            '<button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>' +
            '<h4 class="modal-title" id="myModalLabel">证书登录</h4>' +
            '</div>' +
            '<div class="modal-body">' + content + '</div>' +
            '<div class="modal-footer">' +
            '<button type="button" class="btn btn-primary" id="certLoginDialogOk"> 确 定 </button>' +
            '<button type="button" class="btn btn-default" data-dismiss="modal"> 取 消 </button>' +
            '</div>' +
            '</div>' +
            '</div>' +
            '</div>';

        $("body").append(m);
        var clickOk = false;
        $('#certLoginDialog').on('hide.bs.modal',
            function () {
                $("#certLoginDialog").remove();
                if (clickOk == false) {
                    if (param.error)
                        param.error("用户取消操作");
                }
            });
        $("#certLoginDialogOk").click(function () {
            var password = $("#certLoginDialog [name=loginPassword]").val();
            if (param.checkPassword) {
                var r = param.checkPassword(password);
                if (!r.result) {
                    $("#password-group").addClass("has-error");
                    alert(r.message);
                    return;
                }
            }

            clickOk = true;
            $("#certLoginDialog").modal('hide');
            param.success(password);
        });
        $("#certLoginDialog").modal('show');
    };

    /**
     * 登录设备
     * @param param
     * {
     *     device：设备对象
     *     checkPassword：function(password){}  检测密码
     *     success：function(password){}
     *     fail：function(e){}
     * }
     */
    MiddlewareUiBootstrap.prototype.loginDevice = function (param) {
        var content = '<form class="form-horizontal" role="form" >' +
            '<div class="form-group">' +
            '<label for="itemName" class="col-sm-2 control-label">设备:</label>' +
            '<div class="col-sm-8" >' +
            '<input type="text" name="itemName" class="form-control" disabled="disabled" value="' + param.device.deviceName + '"/>' +
            '</div>' +
            '</div>' +
            '<div class="form-group" id="password-group">' +
            '<label for="loginPassword" class="col-sm-2 control-label">密码:</label>' +
            '<div class="col-sm-8" >' +
            '<input type="password" id="loginPassword" name="loginPassword" class="form-control" placeholder="输入您的设备密码"/>' +
            '</div>' +
            '</div>' +
            '</form>';

        var m = '<div class="modal fade" id="deviceLoginDialog" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true" style="z-index: 9999; ">' +
            '<div class="modal-dialog">' +
            '<div class="modal-content">' +
            '<div class="modal-header">' +
            '<button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>' +
            '<h4 class="modal-title" id="myModalLabel">设备登录</h4>' +
            '</div>' +
            '<div class="modal-body">' + content + '</div>' +
            '<div class="modal-footer">' +
            '<button type="button" class="btn btn-primary" id="deviceLoginDialogOk"> 确 定 </button>' +
            '<button type="button" class="btn btn-default" data-dismiss="modal"> 取 消 </button>' +
            '</div>' +
            '</div>' +
            '</div>' +
            '</div>';

        $("body").append(m);
        var clickOk = false;
        $('#deviceLoginDialog').on('hide.bs.modal',
            function () {
                $("#deviceLoginDialog").remove();
                if (clickOk == false) {
                    if (param.error)
                        param.error("用户取消操作");
                }
            });
        $("#deviceLoginDialogOk").click(function () {
            var password = $("#deviceLoginDialog [name=loginPassword]").val();
            if (param.checkPassword) {
                var r = param.checkPassword(password);
                if (!r.result) {
                    $("#password-group").addClass("has-error");
                    alert(r.message);
                    return;
                }
            }

            clickOk = true;
            $("#deviceLoginDialog").modal('hide');
            param.success(password);
        });
        $("#deviceLoginDialog").modal('show');
    };

    /**
     * 选择印章。
     * @param param
     * {
     *     seals：印章列表对象
     *     success：function(seal){}
     *     fail：function(e){}
     * }
     */
    MiddlewareUiBootstrap.prototype.selectSeal = function (param) {
        var selectControl = '<select class="form-control" name="sealChooseSelect">';
        for (var i = 0; i < param.seals.length; i++) {
            selectControl += '<option value="' + i + '" >' + param.seals[i].sealName + '</option>';
        }
        selectControl += '</select>';

        var content = '<form class="form-horizontal" role="form" >' +
            '<div class="form-group">' +
            '<label for="itemName" class="col-sm-2 control-label">印章:</label>' +
            '<div class="col-sm-8" >' +
            selectControl +
            '</div>' +
            '</div>' +
            '</form>';

        var m = '<div class="modal fade" id="sealChooseDialog" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true" style="z-index: 9999; ">' +
            '<div class="modal-dialog">' +
            '<div class="modal-content">' +
            '<div class="modal-header">' +
            '<button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>' +
            '<h4 class="modal-title" id="myModalLabel">选择印章</h4>' +
            '</div>' +
            '<div class="modal-body">' + content + '</div>' +
            '<div class="modal-footer">' +
            '<button type="button" class="btn btn-primary" id="sealChooseDialogOk">确 定</button>' +
            '<button type="button" class="btn btn-default" data-dismiss="modal">取 消</button>' +
            '</div>' +
            '</div>' +
            '</div>' +
            '</div>';

        $("body").append(m);
        var clickOk = false;
        $('#sealChooseDialog').on('hide.bs.modal',
            function () {
                $("#sealChooseDialog").remove();
                if (clickOk == false) {
                    if (param.fail)
                        param.fail(new Error("用户取消操作"));
                }
            });
        $("#sealChooseDialogOk").click(function () {
            var selectIndex = $("#sealChooseDialog [name=sealChooseSelect]").val();
            clickOk = true;
            $("#sealChooseDialog").modal('hide');
            param.success(param.seals[selectIndex]);
        });
        $("#sealChooseDialog").modal('show');
    };

    /**
     * 登录印章
     * @param param
     * {
     *     seal：印章对象
     *     checkPassword：function(password){}  检测密码
     *     success：function(password){}
     *     fail：function(e){}
     * }
     */
    MiddlewareUiBootstrap.prototype.loginSeal = function (param) {
        var content = '<form class="form-horizontal" role="form" >' +
            '<div class="form-group">' +
            '<label for="itemName" class="col-sm-2 control-label">印章:</label>' +
            '<div class="col-sm-8" >' +
            '<input type="text" name="itemName" class="form-control" disabled="disabled" value="' + param.seal.sealName + '"/>' +
            '</div>' +
            '</div>' +
            '<div class="form-group" id="password-group">' +
            '<label for="loginPassword" class="col-sm-2 control-label">密码:</label>' +
            '<div class="col-sm-8" >' +
            '<input type="password" id="loginPassword" name="loginPassword" class="form-control" placeholder="输入您的密码"/>' +
            '</div>' +
            '</div>' +
            '</form>';

        var m = '<div class="modal fade" id="sealLoginDialog" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true" style="z-index: 9999; ">' +
            '<div class="modal-dialog">' +
            '<div class="modal-content">' +
            '<div class="modal-header">' +
            '<button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>' +
            '<h4 class="modal-title" id="myModalLabel">印章证书登录</h4>' +
            '</div>' +
            '<div class="modal-body">' + content + '</div>' +
            '<div class="modal-footer">' +
            '<button type="button" class="btn btn-primary" id="sealLoginDialogOk"> 确 定 </button>' +
            '<button type="button" class="btn btn-default" data-dismiss="modal"> 取 消 </button>' +
            '</div>' +
            '</div>' +
            '</div>' +
            '</div>';

        $("body").append(m);
        var clickOk = false;
        $('#sealLoginDialog').on('hide.bs.modal',
            function () {
                $("#sealLoginDialog").remove();
                if (clickOk == false) {
                    if (param.error)
                        param.error("用户取消操作");
                }
            });
        $("#sealLoginDialogOk").click(function () {
            var password = $("#sealLoginDialog [name=loginPassword]").val();
            if (param.checkPassword) {
                var r = param.checkPassword(password);
                if (!r.result) {
                    $("#password-group").addClass("has-error");
                    alert(r.message);
                    return;
                }
            }

            clickOk = true;
            $("#sealLoginDialog").modal('hide');
            param.success(password);
        });
        $("#sealLoginDialog").modal('show');
    };

    /**
     * 选择印章并登录印章
     * @param param
     * {
     *     seal：印章对象
     *     checkPassword：function(password){}  检测密码
     *     success：function(password){}
     *     fail：function(e){}
     * }
     */
    MiddlewareUiBootstrap.prototype.selectAndLoginSeal = function (param) {

        var selectControl = '<select class="form-control" name="sealChooseSelect">';
        for (var i = 0; i < param.seals.length; i++) {
            selectControl += '<option value="' + i + '" >' + param.seals[i].sealName + '</option>';
        }
        selectControl += '</select>';

        var content = '<form class="form-horizontal" role="form" >' +
            '<div class="form-group">' +
            '<label for="itemName" class="col-sm-2 control-label">印章:</label>' +
            '<div class="col-sm-8" >' +
            selectControl +
            '</div>' +
            '</div>' +
            '<div class="form-group" id="password-group">' +
            '<label for="loginPassword" class="col-sm-2 control-label">密码:</label>' +
            '<div class="col-sm-8" >' +
            '<input type="password" id="loginPassword" name="loginPassword" class="form-control" placeholder="输入您的密码"/> ' +
            '<input style="display: none" /> ' +
            '</div>' +
            '</div>' +
            '</form>';


        var m = '<div class="modal fade" id="sealLoginDialog" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true" style="z-index: 9999; ">' +
            '<div class="modal-dialog">' +
            '<div class="modal-content">' +
            '<div class="modal-header">' +
            '<button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>' +
            '<h4 class="modal-title" id="myModalLabel">印章证书登录</h4>' +
            '</div>' +
            '<div class="modal-body">' + content + '</div>' +
            '<div class="modal-footer">' +
            '<button type="button" class="btn btn-primary" id="sealLoginDialogOk"> 确 定 </button>' +
            '<button type="button" class="btn btn-default" data-dismiss="modal"> 取 消 </button>' +
            '</div>' +
            '</div>' +
            '</div>' +
            '</div>';

        $("body").append(m);
        var clickOk = false;
        $('#sealLoginDialog').on('hide.bs.modal',
            function () {
                $("#sealLoginDialog").remove();
                if (clickOk == false) {
                    if (param.error)
                        param.error("用户取消操作");
                }
            });
        $("#sealLoginDialogOk").click(function () {
            var password = $("#sealLoginDialog [name=loginPassword]").val();
            if (param.checkPassword) {
                var r = param.checkPassword(password);
                if (!r.result) {
                    $("#password-group").addClass("has-error");
                    alert(r.message);
                    return;
                }
            }

            var selectIndex = $("#sealLoginDialog [name=sealChooseSelect]").val();

            clickOk = true;
            $("#sealLoginDialog").modal('hide');
            var selResult = {
                seal: param.seals[selectIndex],
                password: password
            };
            param.success(selResult);
        });
        $("#sealLoginDialog").modal('show');
    };


    /**
     * @description:选择认证类型
     * @param param {
     *     authTypesNames,认证类型名称数组
     *     success:function(authType)｛｝认证类型，整形
     *     fail:function(e){}
     * }
     *
     */
    MiddlewareUiBootstrap.prototype.selectAuthType = function (param) {
        var selectControl = '<select class="form-control" name="sealChooseSelect">';
        for (var i = 0; i < param.authTypesNames.length; i++) {
            selectControl += '<option value="' + i + '" >' + param.authTypesNames[i].showName + '</option>';
        }
        selectControl += '</select>';

        var content = '<form class="form-horizontal" role="form" >' +
            '<div class="form-group">' +
            '<label for="itemName" class="col-sm-2 control-label">认证类型:</label>' +
            '<div class="col-sm-8" >' +
            selectControl +
            '</div>' +
            '</div>' +
            '</form>';

        var m = '<div class="modal fade" id="sealChooseDialog" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true" style="z-index: 9999; ">' +
            '<div class="modal-dialog">' +
            '<div class="modal-content">' +
            '<div class="modal-header">' +
            '<button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>' +
            '<h4 class="modal-title" id="myModalLabel">选择认证方式</h4>' +
            '</div>' +
            '<div class="modal-body">' + content + '</div>' +
            '<div class="modal-footer">' +
            '<button type="button" class="btn btn-primary" id="sealChooseDialogOk">确 定</button>' +
            '<button type="button" class="btn btn-default" data-dismiss="modal">取 消</button>' +
            '</div>' +
            '</div>' +
            '</div>' +
            '</div>';

        $("body").append(m);
        var clickOk = false;
        $('#sealChooseDialog').on('hide.bs.modal',
            function () {
                $("#sealChooseDialog").remove();
                if (clickOk == false) {
                    if (param.fail)
                        param.fail(new Error("用户取消操作"));
                }
            });
        $("#sealChooseDialogOk").click(function () {
            var selectIndex = $("#sealChooseDialog [name=sealChooseSelect]").val();
            clickOk = true;
            $("#sealChooseDialog").modal('hide');
            param.success(param.authTypesNames[selectIndex].type);
        });
        $("#sealChooseDialog").modal('show');
    };


    /**
     * @description:证书密码认证，返回用户输入的证书密码
     * @param param {
     *     certSubjectId, 当前证书唯一项
     *     success:function(passwrod){}
     *     fail:function(e){}
     * }
     */
    MiddlewareUiBootstrap.prototype.authCertPassWord = function (param) {

        var content = '<form class="form-horizontal" role="form" >' +
            '<div class="form-group">' +
            '<label for="itemName" class="col-sm-2 control-label">认证证书:</label>' +
            '<div class="col-sm-8" >' +
            '<input type="text" name="itemName" class="form-control" disabled="disabled" value="' + param.certSubjectId + '"/>' +
            '</div>' +
            '</div>' +
            '<div class="form-group" id="password-group">' +
            '<label for="loginPassword" class="col-sm-2 control-label">密码:</label>' +
            '<div class="col-sm-8" >' +
            '<input type="password" id="loginPassword" name="loginPassword" class="form-control" placeholder="输入您的密码"/>' +
            '</div>' +
            '</div>' +
            '</form>';

        var m = '<div class="modal fade" id="sealLoginDialog" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true" style="z-index: 9999; ">' +
            '<div class="modal-dialog">' +
            '<div class="modal-content">' +
            '<div class="modal-header">' +
            '<button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>' +
            '<h4 class="modal-title" id="myModalLabel">证书密码认证</h4>' +
            '</div>' +
            '<div class="modal-body">' + content + '</div>' +
            '<div class="modal-footer">' +
            '<button type="button" class="btn btn-primary" id="sealLoginDialogOk"> 确 定 </button>' +
            '<button type="button" class="btn btn-default" data-dismiss="modal"> 取 消 </button>' +
            '</div>' +
            '</div>' +
            '</div>' +
            '</div>';

        $("body").append(m);
        var clickOk = false;
        $('#sealLoginDialog').on('hide.bs.modal',
            function () {
                $("#sealLoginDialog").remove();
                if (clickOk == false) {
                    if (param.error)
                        param.error("用户取消操作");
                }
            });
        $("#sealLoginDialogOk").click(function () {
            var password = $("#sealLoginDialog [name=loginPassword]").val();
            if (param.checkPassword) {
                var r = param.checkPassword(password);
                if (!r.result) {
                    $("#password-group").addClass("has-error");
                    alert(r.message);
                    return;
                }
            }

            clickOk = true;
            $("#sealLoginDialog").modal('hide');
            param.success(password);
        });
        $("#sealLoginDialog").modal('show');


    };

    /**
     * @description:证书短信认证，返回用户输入的短信验证码
     * @param param {
     *     certSubjectId, 当前证书唯一项
     *     success:function(verifyCode){}
     *     fail:function(e){}
     * }
     */
    MiddlewareUiBootstrap.prototype.authCertVerifyCode = function (param) {

        var content = '<form class="form-horizontal" role="form" >' +
            '<div class="form-group">' +
            '<label for="itemName" class="col-sm-2 control-label">认证证书:</label>' +
            '<div class="col-sm-8" >' +
            '<input type="text" name="itemName" class="form-control" disabled="disabled" value="' + param.certSubjectId + '"/>' +
            '</div>' +
            '</div>' +
            '<div class="form-group" id="password-group">' +
            '<label for="loginPassword" class="col-sm-2 control-label">验证码:</label>' +
            '<div class="col-sm-8" >' +
            '<input type="text" id="loginPassword" name="loginPassword" class="form-control" placeholder="输入您手机上的验证码"/>' +
            '</div>' +
            '</div>' +
            '</form>';

        var m = '<div class="modal fade" id="sealLoginDialog" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true" style="z-index: 9999; ">' +
            '<div class="modal-dialog">' +
            '<div class="modal-content">' +
            '<div class="modal-header">' +
            '<button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>' +
            '<h4 class="modal-title" id="myModalLabel">证书短信认证</h4>' +
            '</div>' +
            '<div class="modal-body">' + content + '</div>' +
            '<div class="modal-footer">' +
            '<button type="button" class="btn btn-primary" id="sealLoginDialogOk"> 确 定 </button>' +
            '<button type="button" class="btn btn-default" data-dismiss="modal"> 取 消 </button>' +
            '</div>' +
            '</div>' +
            '</div>' +
            '</div>';

        $("body").append(m);
        var clickOk = false;
        $('#sealLoginDialog').on('hide.bs.modal',
            function () {
                $("#sealLoginDialog").remove();
                if (clickOk == false) {
                    if (param.error)
                        param.error("用户取消操作");
                }
            });
        $("#sealLoginDialogOk").click(function () {
            var password = $("#sealLoginDialog [name=loginPassword]").val();
            if (param.checkPassword) {
                var r = param.checkPassword(password);
                if (!r.result) {
                    $("#password-group").addClass("has-error");
                    alert(r.message);
                    return;
                }
            }

            clickOk = true;
            $("#sealLoginDialog").modal('hide');
            param.success(password);
        });
        $("#sealLoginDialog").modal('show');


    };

    /**
     * @description 人脸认证界面
     * @param param
     */
    MiddlewareUiBootstrap.prototype.authCertFace = function (param) {

        var content = '<form class="form-horizontal" role="form" >' +
            '<div class="form-group">' +
            '<label for="itemName" class="col-sm-2 control-label">认证证书:</label>' +
            '<div class="col-sm-8" >' +
            '<input type="text" name="itemName" class="form-control" disabled="disabled" value="' + param.certSubjectId + '"/>' +
            '</div>' +
            '</div>' +
            '<div class="form-group" id="password-group">' +
            '<label for="loginPassword" class="col-sm-2 control-label">人脸图片Base64:</label>' +
            '<div class="col-sm-8" >' +
            '<input type="text" id="loginPassword" name="loginPassword" class="form-control" placeholder="请按照顺序点击按钮"/>' +
            '</div>' +
            '</div>' +
            '<div class="form-group" id="password-group">' +
            '<label for="btnStart" class="col-sm-2 control-label">采集操作:</label>' +
                '<div class="col-sm-4" >' +
                '<button type="button" class="btn btn-default" id="btnStart"> ①打开摄像头 </button>' +
                '</div>' +
                '<div class="col-sm-4" >' +
                '<button type="button" class="btn btn-default" id="btnGet"> ②采集图像并关闭 </button>' +
                '</div>' +
            '</div>' +
            '</form>';

        var m = '<div class="modal fade" id="sealLoginDialog" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true" style="z-index: 9999; ">' +
            '<div class="modal-dialog">' +
            '<div class="modal-content">' +
            '<div class="modal-header">' +
            '<button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>' +
            '<h4 class="modal-title" id="myModalLabel">证书人脸认证</h4>' +
            '</div>' +
            '<div class="modal-body">' + content + '</div>' +
            '<div class="modal-footer">' +
            '<button type="button" class="btn btn-primary" id="sealLoginDialogOk"> 确 定 </button>' +
            '<button type="button" class="btn btn-default" data-dismiss="modal"> 取 消 </button>' +
            '</div>' +
            '</div>' +
            '</div>' +
            '</div>';

        $("body").append(m);
        var clickOk = false;
        $('#sealLoginDialog').on('hide.bs.modal',
            function () {
                $("#sealLoginDialog").remove();
                if (clickOk == false) {
                    if (param.error)
                        param.error("用户取消操作");
                }
            });
        $("#sealLoginDialogOk").click(function () {
            var password = $("#sealLoginDialog [name=loginPassword]").val();
            if (param.checkPassword) {
                var r = param.checkPassword(password);
                if (!r.result) {
                    $("#password-group").addClass("has-error");
                    alert(r.message);
                    return;
                }
            }

            clickOk = true;
            $("#sealLoginDialog").modal('hide');
            param.success(password);
        });

        $("#btnStart").click(function () {
            param.webJsObj.faceServiceimp.getCameraNum({
                success: function (json) {
                    if (json.cameraNum > 0) {
                        param.webJsObj.faceServiceimp.openCamera({
                            'indexColor': 0,
                            'indexInfrar': -1,
                            success: function () {

                            },
                            fail: function (e) {
                                alert(e.message);
                            }
                        });

                    } else {
                        alert('没有找到摄像头');
                    }

                },
                fail: function (e) {
                    alert(e.message);
                }
            });

        });

        $("#btnGet").click(function () {
            param.webJsObj.faceServiceimp.faceImageData({
                success: function (json) {
                    if (json.dataBase64.length > 0) {
                        $("#sealLoginDialog [name=loginPassword]").val('data:image/jpeg;base64,' + json.dataBase64);
                    } else {
                        alert('没有获取到图片信息');
                    }
                    param.webJsObj.faceServiceimp.closeCamera({
                        'indexColor': 0,
                        'indexInfrar': -1,
                        success: function () {
                        },
                        fail: function (e) {
                            alert(e.message);
                        }
                    });

                },
                fail: function (e) {
                    alert(e.message);
                }
            });

        });
        $("#sealLoginDialog").modal('show');


    };

    /**
     * 进度
     * @param param
     * {
     *     title：
     *     currentLength:
     *     allLength
     *     success：function(){}
     *     fail：function(e){}
     * }
     */
    MiddlewareUiBootstrap.prototype.progress = function (param) {
        var finish = false;
        if (param.allLength <= 0) {
            param.success();
            return;
        }

        if (param.currentLength === 0) {
            var content = '<div class="progress">\n' +
                '    <div id="progressDialog-progressbar" class="progress-bar progress-bar-success" role="progressbar"' +
                '         aria-valuenow="60" aria-valuemin="0" aria-valuemax="100"' +
                '         style="width: 0%;">' +
                '    </div>' +
                '</div>';

            var m = '<div class="modal fade" id="progressDialog" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true" style="z-index: 9999; ">' +
                '<div class="modal-dialog">' +
                '<div class="modal-content">' +
                '<div class="modal-header">' +
                '<button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>' +
                '<h4 class="modal-title" id="progressDialog-label">' + param.title + '</h4>' +
                '</div>' +
                '<div class="modal-body">' + content + '</div>' +
                '<div class="modal-footer">' +
                '<button type="button" class="btn btn-default" data-dismiss="modal">取 消</button>' +
                '</div>' +
                '</div>' +
                '</div>' +
                '</div>';

            $("body").append(m);
            $('#progressDialog').on('hide.bs.modal',
                function () {
                    $("#progressDialog").remove();
                    if (finish == false) {
                        if (param.fail) {
                            param.fail(new Error("用户取消操作"));
                        }
                    }
                });
            $("#progressDialog").modal('show');
            if (param.success) {
                param.success();
            }
        } else if (param.currentLength === param.allLength) {
            finish = true;
            $('#progressDialog').off('hide.bs.modal');
            $("#progressDialog").modal('hide');
            $("#progressDialog").remove();
            $(".modal-backdrop,.fade,.in").remove();
            setTimeout(function () {
                if (param.success) {
                    param.success();
                }
            }, 100);

        } else {
            var p = param.currentLength * 100 / param.allLength;
            console.log(p);
            $("#progressDialog-progressbar").css("width", p + "%");
            if (param.success) {
                param.success();
            }
        }
    };

    /**
     * 添加右键菜单
     * @param param
     * {
     *     divId: "",
     *     actions: [{
     *         name: ""
     *         onClick: function(){
     *
     *         }
     *     },...]
     * }
     */
    MiddlewareUiBootstrap.prototype.addContextMenu = function (param) {
        var actions = param.actions;
        var menuActions = [];
        for (var i = 0; i < actions.length; i++) {
            menuActions.push(
                {
                    name: actions[i].name,
                    onClick: actions[i].onClick
                }
            );
        }

        /*if($s.Util.isMobile()){
            var menu = new BootstrapMenu('#'+param.divId, {
                menuEvent: 'click',
                menuSource: 'mouse',
                menuPosition: 'belowLeft',
                actions: menuActions
            });
        }
        else{*/
        var menu = new BootstrapMenu('#' + param.divId, {
            menuEvent: 'right-click',
            menuSource: 'mouse',
            menuPosition: 'belowLeft',
            actions: menuActions
        });
        //}
    };

    /**
     * 显示信息
     * @param param
     * {
     *     id:
     *     title: "对话框标题",
     *     infoes: [{
     *        caption: "", 标题
     *        items:[{
     *              name: "",
     *              value: "",
     *              onClick: function  可选
     *          },...]
     *      },...]
     *     success：function(){}
     *     fail：function(e){}
     * }
     */
    MiddlewareUiBootstrap.prototype.showInfo = function (param) {
        if (!param.id) {
            param.id = "sealDialogInfo"
        }
        var content = '';
        for (var i = 0; i < param.infoes.length; i++) {
            if (i !== 0) {
                content += "<p></p>";
            }

            var table = '<table class="table table-striped">';
            table += '<caption>' + param.infoes[i].caption + '</caption>' +
                '<tbody>';
            var info = param.infoes[i];
            for (var j = 0; j < info.items.length; j++) {
                if (info.items[j].onClick) {
                    table += '<tr><td>' + info.items[j].name + '</td><td><a href="#" id="__hebca_showInfo_item_' + j + '">' + info.items[j].value + '</a></td></tr>';
                } else {
                    table += '<tr><td>' + info.items[j].name + '</td><td style="word-wrap: break-word; word-break: break-all">' + info.items[j].value + '</td></tr>';
                }
            }
            table += '</tbody>';
            table += '</table>';

            content += table;
        }

        var m = '<div class="modal fade" id="' + param.id + '" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true" style="z-index: 9999; ">' +
            '<div class="modal-dialog">' +
            '<div class="modal-content">' +
            '<div class="modal-header">' +
            '<button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>' +
            '<h4 class="modal-title" id="myModalLabel">' + param.title + '</h4>' +
            '</div>' +
            '<div class="modal-body">' + content + '</div>' +
            '<div class="modal-footer">' +
            '<button type="button" class="btn btn-default" data-dismiss="modal">关 闭</button>' +
            '</div>' +
            '</div>' +
            '</div>' +
            '</div>';

        $("body").append(m);

        //添加onclick事件
        for (var i = 0; i < param.infoes.length; i++) {
            var info = param.infoes[i];
            for (var j = 0; j < info.items.length; j++) {
                if (info.items[j].onClick) {
                    $("#__hebca_showInfo_item_" + j).click(info.items[j].onClick);
                }
            }
        }

        var infoDialog = $('#' + param.id);
        infoDialog.on('hide.bs.modal',
            function () {
                infoDialog.remove();
                if (param.success) {
                    param.success();
                }
            });

        infoDialog.modal('show');
    };

    /**
     * 显示Tooltip
     * @param param
     * {
     *     divId: "", 添加的div
     *     tooltip: "",
     * }
     */
    MiddlewareUiBootstrap.prototype.addTooltip = function (param) {
        var seal = $('#' + param.divId);
        seal.attr("data-toggle", 'tooltip');
        seal.attr("data-placement", 'right');
        seal.attr("title", param.tooltip);
    };

    MiddlewareUiBootstrap.prototype.showQrImage = function (param) {

        var img_error = '/9j/4AAQSkZJRgABAQEAYABgAAD/4QAiRXhpZgAATU0AKgAAAAgAAQESAAMAAAABAAEAAAAAAAD//gA8Q1JFQVRPUjogZ2QtanBlZyB2MS4wICh1c2luZyBJSkcgSlBFRyB2OTApLCBxdWFsaXR5ID0gNzUKAP/bAEMAAgEBAgEBAgICAgICAgIDBQMDAwMDBgQEAwUHBgcHBwYHBwgJCwkICAoIBwcKDQoKCwwMDAwHCQ4PDQwOCwwMDP/bAEMBAgICAwMDBgMDBgwIBwgMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDP/AABEIAMgAyAMBIgACEQEDEQH/xAAfAAABBQEBAQEBAQAAAAAAAAAAAQIDBAUGBwgJCgv/xAC1EAACAQMDAgQDBQUEBAAAAX0BAgMABBEFEiExQQYTUWEHInEUMoGRoQgjQrHBFVLR8CQzYnKCCQoWFxgZGiUmJygpKjQ1Njc4OTpDREVGR0hJSlNUVVZXWFlaY2RlZmdoaWpzdHV2d3h5eoOEhYaHiImKkpOUlZaXmJmaoqOkpaanqKmqsrO0tba3uLm6wsPExcbHyMnK0tPU1dbX2Nna4eLj5OXm5+jp6vHy8/T19vf4+fr/xAAfAQADAQEBAQEBAQEBAAAAAAAAAQIDBAUGBwgJCgv/xAC1EQACAQIEBAMEBwUEBAABAncAAQIDEQQFITEGEkFRB2FxEyIygQgUQpGhscEJIzNS8BVictEKFiQ04SXxFxgZGiYnKCkqNTY3ODk6Q0RFRkdISUpTVFVWV1hZWmNkZWZnaGlqc3R1dnd4eXqCg4SFhoeIiYqSk5SVlpeYmZqio6Slpqeoqaqys7S1tre4ubrCw8TFxsfIycrS09TV1tfY2dri4+Tl5ufo6ery8/T19vf4+fr/2gAMAwEAAhEDEQA/AP38ooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKoeKvElr4N8Malq98zJZaVay3lwyjcVjjQuxA78A0AX6K+NP+HmHij+0Pt/8AwiOj/wBi7932X7TJ9s8v/rr9zd3+5jtnvX154V8SWvjLwxpusWLM9lqtrFeW7Mu0tHIgdSR24IoAv0UUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAcD+0l8YJ/gl8L59Ys7WK71CaeO0tEmB8lZHJ+Z8EHaFDHAIyQBkZyPnLwP+114z8IeM7TUPEWstrGhXEoW/tzaxJ9njY4MkXloGBTrtydwBB5IYfVfxS+Hdl8V/AOpaBqHywahFsWQDLQSAhkkX/aRgrDscYPFfB8+kXmi6hqGhatD5OpaXM1rcJ23DuvqrDDA9wQe9AH6G29xHd28csUiSRSKHR0O5XU8gg9wfWuQ/aM/5N78ef8AYu6h/wCk0lea/sM/Fxtc8M3Hg3UJd2oeHUD2RY8zWROFH/bJiE9ArRj1r0r9oz/k3vx5/wBi7qH/AKTSUAfnA3/Ioj/rl/Sv0f8A2c/+Te/Af/Yu6f8A+k0dfnA3/Ioj/rl/Sv0f/Zz/AOTe/Af/AGLun/8ApNHQB2LusaFmIVVGST0Ar4A+M3/BQbx14s+J2oT+Cddh0bwrp85hsFSxgm/tNEOPPkaVGbbIclQuzCFc/Nk17V/wUl+P58B/DeLwVpdxt1zxgjJcFD81pp44lY+hk/1S8cgykEFK+H7LRbzWdQ07QtGt/tWqapcR2VnAp2+ZK5CqCeygnJY8AAk8A0AfpF+x3+0NcftKfCD+276yhsdUsb2TTb5Lfd9neVFR98e4lgrJIhwSSpyMtjJ9UrjP2fvgzY/AH4S6P4XsWWb7DFuurnbta8uHO6WU/wC8xOASdq7V6AV2dABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQBw/xW+P8AoPwivbezv1vry/uU81bWyiEkix5I3tuZVAJBAycnBwDg41vh78VNC+KOnNcaNfx3DRgedA3yT25PZ0PzL356HHBI5rwH9pnwZrHhP4o6t4kuLSa60PVFhYXcY3pZ7YkjKSf3BlSQxG07+uc1wdqqvew6jpd3NY6hDzFcW0hjkTPUBh2PcHgjg0AfblfNH7d3wmNlNZ+PNPj/ANVsstYVRjchOIZj7qx2E8khk6BTWr8Ov2ub3Qmjs/Gdu1xD0Gq2kPzD3lhX8fmjH/AO9e1CbRfil4NmSOW01jRdWgeCTy5N8c8bAqy5B9CQehB9DQB8I+HfF958PfFml+KNLHmXely+YYs4FzGRiSIn0dCRnsSD1Ar7E+LPiaz+IH7LHirVdKkN1Z6t4YvZrYqPmYNayEDHUMOhXqCCOtfMuufsnfELw74nn0LT9HbVrAyFbTUzcRJC8OfleTLBkYD7w25yDt3DGfqz4D/DOT4QfCTR/DtxcJeXFikjTyoDsaSSR5XC552hnIGecAdKAPzZN7D/AMIl/rF/1fXPtX6KfCfxRY/Dz9lbwvq+sTfYbDR/C1ncXckgP7lEtULZHXPHTqTx1rF/4YU+FP8AwkH9o/8ACJweZ53n/Z/tdx9j3Zzj7P5nlbP9jbsxxjHFdH+0l8IpPjr8DvEHhO3ulsLjVIF+zzMDsSWORJYw2OdhZFDY52k4oA/Nz4m/E6++NfxK1rxlqiyQzapL/o9u7bvsVsvEMI7fKvUjALlmx8xr6K/4JjfAQ6zq158TtUh/dQmXTtADDqeUuLkfrCpB7TAjkGvKtA/YS+KniTxxb+G9Q8PyaPY+aqXms/aYZLWGDPzSxkNmRiv3U2hskbgg3EfoLaReHPgX8NLeFriw8P8Ahnw5aJAJbqdYYLWJAFXe7ED05JySe5NAHRVyfxf+OXhP4C+Gv7W8Wa3Z6PasSsKyEtNdMMZWKJQXkbkHCKSBycDmvlL9oX/gq59pNxpPws0/7Q3KN4g1KBlhXjrb27YZzzw8u1QR9xwc18geK/EGoeMvEU+veJtWvdc1i4/1l5ey75MZJCr2RBk4RQFGeAKAP1C/Z4/bN8DftNalfaf4dvL6HVtPj+0S2F/bG3naHcF81OqsgZlB2klSy7gNy59Wr81v+CcXwm8UeOv2jPDvjLTNPu7Pwr4fNy13qkiGO3vA8EsIgiJ/1xLsC23KpsJJDBQf0poAKKKKACiiigAooooAKKKKACiiigAooqrq2tWeg2n2i+u7aztwQpknlWNAT0GWIFAFplDqQRkHgg968e+Jv7Iml6/JJfeGZY/D2pHLGBVzYzn3jH+rJ45Tgckqxr0H/ha3hf8A6GTQf/BhD/8AFUf8LX8L/wDQyaD/AODCH/4qgD5P8T6Rq3w/1NdP8TabJYSSErFKfnt7n/rnIPlb1x94Z5ArY/Z81G80X45aPb6HLJ5OpM/9o26MfJkhEbEu46ZU4w3XJC5wxB+jdd8Z+CfFumSafqGr+GdQtLnCvBNeQSK/pwW656dwal8A/B3wz8MZp5tD0mGymuhtkm3vLIy9dodyxC5wdoOMgcUAdNRRRQAUUUUAFfmH/wAFEPFXiDxZ+1d4g0nxJdXS6VoLQHRbB2ItY4GgRvPRfus7sZMyctkFM4QAfp5Xnvxr/ZX+H/7Q1zZ3HjDw7b6pdaehjhuVuJrWdEJzsMkLo7Jkk7WJUEk45NAH5c/DP4d+JPjX4kOi+CtDutbvI8Cd4gEt7MHo00rYSMYBIBOWxhQx4r7U/Z0/4JW+H/Bktvq3xFubfxjrCEOunIpXSLZuOCjANcd+ZAEIPMeRmvXvBfxs+Cfwn8PxaFoXjT4Z6Dp9iSi2dtrVlCsbfxFgH5Ynkk/MTySTWt/w1p8K/wDopnw//wDCis//AI5QB3lpaRafaRW9vFHDBCgjjjjUKkagYCgDgADjAqSvPv8AhrT4V/8ARTPh9/4UVn/8crrvCXjTR/H2jLqWhatputafIxVbqwukuYWI6gOhK5H1oA06KKKACiiigAooooAKKKKACiiigArx34/yQx/EfR/7SDHT/sT/AGbf/q/O3/vP+BbfL/D8a9iqrq2i2ev2Zt760try3YgmKeJZEJHThgRQB4Ibrw/6W/6UG58P/wB23/SvZf8AhU/hb/oW9A/8F0P/AMTR/wAKn8Lf9C3oH/guh/8AiaAPEtTuPD5sJM/Z8bT6V6v+zuZz8IdJ87zdv737P5nXyPNfysf7Ozbt/wBnHarmr+BfBfhmya8vNF8N2cMJz5sljCuD2x8vX0A5NXvCfxF0XxrLLFpl8s8sA3NG0bxOF6ZCuASPcccigDcooooAKKKKACvC/wDgpR/an/DFHjj+yftXmeTbfavs+d32P7VD9qzj+DyPN39tm/PGa90rzf47ftc/Df8AZqubG38b+KrHRLrUl329sY5bi4kTON5jiV3EeQRvIC5BGeKAPx/ibS/LXHk9BjAWnE6Wx58n9K/XLwd8Dvgp8VPDtvr+h+C/hjr2makDLFfWmjWVxHPzyd6oQTnIPcHIPNan/DJnwr/6Jn8P/wDwnbP/AON0AfjznSx/zy/Svrz/AII1fbv+FueOv7P87/hHf7Mg+2bf9T9r839z7b/L87pzjGf4a+yv+GTPhX/0TP4f/wDhO2f/AMbrrfCXgvR/AOjLpuhaTpui6fGxZbWwtUtoVJ6kIgC5P0oA06KKKACiiigAooooAKKKKACiiigAooooAbNMtvE0kjLHGgLMzHAUDqSa8/8AFHx0i81rXw9AupTDg3T5FrGfYjmT/gOB/tdq534lX1z4p8fajp1/cSR6fpzRiG1DbY5Mor72H8ZyTjPAx65zl/2rHDdLYaZayXl5IPkhgTc+PX0Ue54FAD7uwm1e8+3a5eyX1wv3fMICReyIPlX8Bz3zUvw7t5tZ+KOnz6TG32exZ/tk6j92iFCCjHoSxxheucHHGa6Pw38DrjWGW48SXB2HkWFtIQo9pJByfouBkfeIrv2Fj4P0FikcNlY2MZbZGgVY1HJwB/IdSaAL1FeVN4v13Upm1Jb6S15LR221TGi9lIx8xx1PX0xxj0Hwb4gbxN4Ytb6RFikmUh1H3QysVOPbIJHtQBqUV8y/8Pjf2bf+E8/4R3/haGm/a/tP2T7X9gvP7N3525+2+T9n8v8A6a+Z5eOd2Oa9I/bT/aHm/ZV/Zf8AFnj210+PVLzRIIltLaQkRPPPPHbxF8c+WskqswBBKqcEHmgD1Kvx5/4KoeEfFXhf9s/xNqnii1vDpevNB/YN+6H7LPapAgEMTfdDRsH3pw24l8YkDNn/AA8/4KyfHDwj8VbPxXr3iZvEWgtcq+p+H1sLeG1ktSfnjg2qHjdVJKMXJ3Bd5cbgf1tuLDwj+0f8KLZri10rxZ4R8UWUV5CtxAJre8gkUSRyBWHoVYHAIODwRQB+KPwN/aA8a/s1eJ21bwLr9zpMkzhrq0P72x1DHGJ4D8r8cBhh1BO1lzmv0T/ZS/4LBeDPi4bXRvH0cPgHxLJhBcTS7tHvW/2J25hJOTslwoyAJHJrzH9qv/gi3cac1xrXwdvmkj5dvDOqXPI68W105+gCTk9STKOFr4U8W+GtS8FeJLrQvEelX2iazZkC4sb6BoZo89CVYcqeoYcMOQSOaAP38SRZUVlYMrDIIPBFLX5U/wDBJX9pbxt4X/aT8O/DeLU7zVvBWuQ3SNp1wxmj0fyreSdZYCeYl3RhCgIQ+cTt34NfqtQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQBzvjT4XaX46uori6W4huoV8sT28nluyZJ2nqCMknkZGTjGTWh4X8H6b4NsTb6bax26scuw+aSU+rMeWP1NaVFABXAfFTXDq+qRaLC37qHbNeY7nqifyY/8BrrfFviOPwroFxeOA7INsUecea54VfxP5DJ7V5jZ7rGzmurp91xOzSyuf4mJyTQBJPaS63qNtpNqSsl02GcD/VIOWf8B09Tgd6l/bMt18N/sPfFiOxLW32LwPrHkMjYaMrYTYIPXIxnPrXT/CTw60FhJq9wv+kakB5YP/LOHqv/AH194+230rm/26P+TJfjF/2I+tf+kE9AH83flr9n24+XbjHbpX9Ff7OHgHTPjd/wTq+HfhzxLC2paX4l+HulWl+rt88qy6fCGYN1DgncGHIYAjkZr+db/ll+Ff0hfsL/APJkvwd/7EfRf/SCCgD8Y/jD8G9W/Z2+MHiL4f6+fMvvD9yYo7jbtW+t2AaC4UdMSRlWIBO1iynlTX3B/wAESf2q/Lh1L4M65c4ksxLq3hh5GHzwlt1zaA9yjt5qjklZJeixiuw/4LT/ALJzfEX4WWvxT0O1MmveA4Wj1VY1+e70ksWcnjn7O5aUZIAja4PJxX5teEPHWrfDnxdofi7w3ci117w5dx39jKc7d6/wuBgmN13I6/xKzDvQB/QLXn/7QP7L3gb9p/wyul+M9BtdUWEN9luxmK8sWP8AFDMuHTkAkA7WwAwYcVa/Zy+O2j/tL/BPw7430PK2OvWolaBm3PZzKSk0DnAy0ciuhI4JXIyCDXbUAeI/sofsAfD/APY71LUtR8Mx6tqGs6pF9ml1LVblZ7hINwbyU2IiKhZVJwuWKruJ2rj26iigAooooAKKKKACiiigAooooAKKKKACiiigAooooAw/iB4Vk8W6IkMMix3FvMtxFv8AuMwBGGx2IY89jg81x9h4A1bxBqkMOo2Ys7GJg05MqN5wH8ChSTz0JOOM9+K9MooAFG0YHAHAA7V5X+3R/wAmS/GL/sR9a/8ASCevVKx/iH4F0/4o+ANc8M6vHJLpPiLT7jTL1EbazwTxtFIAexKsee1AH8wP/LL8K/pC/YX/AOTJfg7/ANiPov8A6QQV+cP/ABDb+MP+E6+zf8LO8O/8Ir5+Ptv9nTf2l5H/AFxz5XmY4z5m3POP4a/Vr4eeBdP+F/gDQ/DOkRvDpPh3T7fTLJHbcyQQRrFGCe5CqOaANO+sodTspra5hiuLe4RopYpUDpIjDBVgeCCCQQetfkV8f/8Agkb8WvAPxn1LSPh74X/4SXwTqFy0mkXo1K2hFhA5yILgTSK4MXK7gG3qqkEuxQfr1RQB4n/wT9/ZUu/2Ov2bdP8ACOp6lb6prUt1PqWpTWxb7Ks8zDKQ7gG2Kqou5gCxDNtXdtHtlFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQB//2Q=='
        var qrImgControl = "<img class='center-block' src='data:image/png;base64," + img_error + "'/>";

        var prgControl = '<div class="progress" style="height: 8px; margin-bottom: 0px">\n' +
            '    <div id="progressDialog-progressbar" class="progress-bar progress-bar-success" role="progressbar"' +
            '         aria-valuenow="60" aria-valuemin="0" aria-valuemax="100"' +
            '         style="width: 100%;">' +
            '    </div>' +
            '</div>';

        var content = '<form class="form-horizontal" role="form" >' +
            '<div class="form-group">' +
            '<div id="div_QRImg">' +
            qrImgControl +
            '</div> '+
            '</div>' +

            '<div id="div_span">' +
            '<p><label class=“center-block“ id="imgContextShow"></label></p>'+
            '</div>' +
            '<div id="div_prog">' +
            prgControl +
            '</div> '+

            '</form>';


        var m = '<div class="modal fade" id="qrCodeDialog" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true" style="z-index: 9999; ">' +
            '<div class="modal-dialog">' +
            '<div class="modal-content">' +
            '<div class="modal-header">' +
            '<button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>' +
            '<h4 class="modal-title" id="myModalLabel">使用移证签app扫码</h4>' +
            '</div>' +
            '<div class="modal-body">' + content + '</div>' +
            '<div class="modal-footer">' +
            '<button type="button" class="btn btn-primary" id="refreshQrcodeBtn">刷新</button>' +
            '</div>' +
            '</div>' +
            '</div>' +
            '</div>';

        $("body").append(m);
        var clickOk = false;
        var progressWidth = 100;
        var time_prog;
        var time_lunxun;
        var bwindowClose = false;

        $('#qrCodeDialog').on('show.bs.modal',
            // on dialog open
            function () {
                param.webJsObj.getQrCode({
                    sealContentB64: param.sealContentB64,
                    userId: 'everybody',
                    transType: '0',
                    success: function (qrInfo) {
                        // show qrImg
                        $("#div_QRImg").empty();
                        var qr_img = qrInfo.returnJson.qrcodeBase64Code;
                        $("#div_QRImg").append("<img class='center-block' src='data:image/png;base64," + qr_img + "'/>");
                        // init progress
                        time_prog = setInterval( function () {
                            if (progressWidth <= 0) {
                                $("#imgContextShow").html('二维码已过期，请点击刷新按钮');
                                if ( time_prog != null){
                                    clearInterval(time_prog);
                                    time_prog = null;
                                }
                                //console.log('end  '+ progressWidth);
                            } else {
                                progressWidth -= 100 / Number(qrInfo.returnJson.qrCodeDiff);
                                $("#progressDialog-progressbar").css("width", progressWidth + "%");
                                //console.log('start'+ progressWidth);
                            }
                        }, 1000);
                        time_lunxun = setInterval( function() {
                            param.webJsObj.lunxunGetResult({
                                serviceNo: qrInfo.returnJson.serviceid,
                                success: function (lunxunResult) {
                                    var ret_returnJson = lunxunResult.data;
                                    var ret_status = ret_returnJson.status;
                                    var ret_sealResultB64 = ret_returnJson.sealResult;
                                    var ret_userMobile = ret_returnJson.userMobile;
                                    if  (!(ret_userMobile == "" || ret_userMobile == undefined || ret_userMobile == null) && bwindowClose == false)
                                    {
                                        //用户完成扫码
                                        bwindowClose = true;
                                        $("#imgContextShow").html('扫码成功');
                                        if ( time_prog != null){
                                            clearInterval(time_prog);
                                            time_prog = null;
                                        }
                                    }

                                    if (ret_status == 1 && ret_sealResultB64 != "" ) {
                                        console.log("m_timer_lun1 end");

                                        if ( time_prog != null){
                                            clearInterval(time_prog);
                                            time_prog = null;
                                        }
                                        if ( time_lunxun != null){
                                            clearInterval(time_lunxun);
                                            time_lunxun = null;
                                        }

                                        clickOk = true;
                                        $("#qrCodeDialog").modal('hide');
                                        param.success(ret_sealResultB64);
                                    }
                                },
                                fail: function (error) {
                                    param.fail(error);
                                }
                            })
                        },1000);
                    },
                    fail: function (error) {
                        param.fail(error);
                        $("#qrCodeDialog").modal('hide');
                    }
                });
            });

        $('#qrCodeDialog').on('hide.bs.modal',
            // close
            function () {
                if ( time_prog != null){
                    clearInterval(time_prog);
                    time_prog = null;
                }
                if ( time_lunxun != null){
                    clearInterval(time_lunxun);
                    time_lunxun = null;
                }
                $("#qrCodeDialog").remove();
                if (clickOk == false) {
                    if (param.fail)
                        param.fail(new Error("用户取消操作"));
                }
            });
        $("#refreshQrcodeBtn").click(function () {
            // refresh
            if ( time_prog != null){
                clearInterval(time_prog);
                time_prog = null;
            }
            if ( time_lunxun != null){
                clearInterval(time_lunxun);
                time_lunxun = null;
            }
            progressWidth = 100;
            param.webJsObj.getQrCode({
                sealContentB64: param.sealContentB64,
                userId: 'everybody',
                transType: '0',
                success: function (qrInfo) {
                    // show qrImg
                    $("#div_QRImg").empty();
                    var jstupian = qrInfo.returnJson.qrcodeBase64Code;
                    $("#div_QRImg").append("<img class='center-block' src='data:image/png;base64," + jstupian + "'/>");
                    // init progress
                    time_prog = setInterval( function () {
                        if (progressWidth <= 0) {
                            $("#imgContextShow").html('二维码已过期，请点击刷新按钮');
                            if ( time_prog != null){
                                clearInterval(time_prog);
                                time_prog = null;
                            }
                            console.log('end  '+ progressWidth);
                        } else {
                            progressWidth -= 100 / Number(qrInfo.returnJson.qrCodeDiff);
                            $("#progressDialog-progressbar").css("width", progressWidth + "%");
                            console.log('start'+ progressWidth);
                        }
                    }, 1000);
                    time_lunxun = setInterval( function() {
                        param.webJsObj.lunxunGetResult({
                            serviceNo: qrInfo.returnJson.serviceid,
                            success: function (lunxunResult) {
                                var ret_returnJson = lunxunResult.data;
                                var ret_status = ret_returnJson.status;
                                var ret_sealResultB64 = ret_returnJson.sealResult;
                                var ret_userMobile = ret_returnJson.userMobile;
                                if  (!(ret_userMobile == "" || ret_userMobile == undefined || ret_userMobile == null) && bwindowClose == false)
                                {
                                    //用户完成扫码
                                    bwindowClose = true;
                                    $("#imgContextShow").html('扫码成功');
                                    if ( time_prog != null){
                                        clearInterval(time_prog);
                                        time_prog = null;
                                    }
                                }

                                if (ret_status == 1 && ret_sealResultB64 != "" ) {
                                    console.log("m_timer_lun1 end");

                                    if ( time_prog != null){
                                        clearInterval(time_prog);
                                        time_prog = null;
                                    }
                                    if ( time_lunxun != null){
                                        clearInterval(time_lunxun);
                                        time_lunxun = null;
                                    }

                                    clickOk = true;
                                    $("#qrCodeDialog").modal('hide');
                                    param.success(ret_sealResultB64);
                                }
                            },
                            fail: function (error) {

                                clickOk = true;
                                $("#qrCodeDialog").modal('hide');
                                param.fail(error);
                            }
                        })
                    },1000);
                },
                fail: function (error) {
                    clickOk = true;
                    $("#qrCodeDialog").modal('hide');
                    param.fail(error);
                }
            });
        });
        $("#qrCodeDialog").modal('show');
    };

    MiddlewareUiBootstrap.prototype.showPush = function (param) {
        var content = '<form class="form-horizontal" role="form" >' +
            '<div class="form-group">' +
            '<label for="itemName" class="col-sm-2 control-label">当前用户:</label>' +
            '<div class="col-sm-8" >' +
            '<input type="text" name="itemName" class="form-control" disabled="disabled" value="' + param.userName + '"/>' +
            '</div>' +
            '</div>' +

            '<div class="form-group">' +
            '<label for="itemName" class="col-sm-2 control-label">     </label>' +
            '<div class="col-sm-8" >' +
            '<button type="button" class="btn btn-primary btn-block" id="pushBtn">   盖  章   </button>' +
            '<div id="div_span"' +
            '<p style="text-align: center"><label  id="imgContextShow"></label></p>'+
            '</div>' +
            '</div>' +

            '</div>' +

            '</form>';

        var m = '<div class="modal fade" id="pushDialog" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true" style="z-index: 9999; ">' +
            '<div class="modal-dialog">' +
            '<div class="modal-content">' +
            '<div class="modal-header">' +
            '<button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>' +
            '<h4 class="modal-title" id="myModalLabel">推送盖章</h4>' +
            '</div>' +
            '<div class="modal-body">' + content + '</div>' +
            '<div class="modal-footer">' +
            '<button type="button" class="btn btn-link" id="showQr"> 切换用户</button>' +
            '</div>' +
            '</div>' +
            '</div>' +
            '</div>';

        $("body").append(m);
        var clickOk = false;
        var time_lunxun;
        var bwindowClose = false;
        $('#pushDialog').on('hide.bs.modal',
            function () {
                if ( time_lunxun != null){
                    clearInterval(time_lunxun);
                    time_lunxun = null;
                }

                $("#pushDialog").remove();
                if (clickOk == false) {
                    if (param.fail)
                        param.fail(new Error("用户取消操作"));
                }
            });
        $("#pushBtn").click(function () {
            var selResult = {
                type: 'push',
                signature: ''
            }
            //
            param.webJsObj.getQrCode({
                sealContentB64: param.sealContentB64,
                userId: param.userId,
                transType: '1',
                success: function (qrInfo) {

                    time_lunxun = setInterval( function() {
                        param.webJsObj.lunxunGetResult({
                            serviceNo: qrInfo.returnJson.serviceid,
                            success: function (lunxunResult) {
                                var ret_returnJson = lunxunResult.data;
                                var ret_status = ret_returnJson.status;
                                var ret_sealResultB64 = ret_returnJson.sealResult;
                                var ret_userMobile = ret_returnJson.userMobile;
                                if  (!(ret_userMobile == "" || ret_userMobile == undefined || ret_userMobile == null) && bwindowClose == false)
                                {
                                    bwindowClose = true;
                                    $("#pushBtn").hide();
                                    $("#imgContextShow").html('请在手机移证签中确认签章.<br>如遇到问题，请使用移证签app扫码盖章');
                                }

                                if (ret_status == 1 && ret_sealResultB64 != "" ) {
                                    if ( time_lunxun != null){
                                        clearInterval(time_lunxun);
                                        time_lunxun = null;
                                    }
                                    selResult.signature = ret_sealResultB64;
                                    clickOk = true;
                                    $("#pushDialog").modal('hide');
                                    param.success(selResult);
                                }
                            },
                            fail: function (error) {

                                clickOk = true;
                                $("#pushDialog").modal('hide');
                                param.fail(error);

                            }
                        })
                    },1000);
                },
                fail: function (error) {

                    clickOk = true;
                    $("#pushDialog").modal('hide');
                    param.fail(error);
                }
            });
            //
        });

        $("#showQr").click(function () {

            var selResult = {
                type: 'qr'
            }

            clickOk = true;
            $("#pushDialog").modal('hide');
            param.success(selResult);
        });
        $("#pushDialog").modal('show');
    };

    $m.MiddlewareUiBootstrap = MiddlewareUiBootstrap;
    $m.uiBootstrap = new MiddlewareUiBootstrap();

})(HebcaMiddleware);
